const protocol = 'https';
const server = 'backportal.uniftc.edu.br';
const port = '8282';
const host = protocol + '://' + server; // + ':' + port;

export const environment = {
  production: true,
  ambiente: 'Produção',
  ambienteAbrev: 'PRO',
  fileSize: 4000000,
  fileSizeAdm: 11000000,
  gtag: '',
  secretAD: '%KytQnNoqVn^QX*dQ9tAbZ#@@u',
  secretAluno: 'a&ECNJJnfhUcwOb4U%oJKhO#q^',
  secretDocente: 'EEgCAx#ZoweXmhbA2h*SrsLZFo',
  secretKey: 't5FP$NvzQ^*85C!3',
  secretTopdesk: 'btCUUg3ID6',
  secretVaquinha: '5&fDo4f&@%@owm9F',
  tipo: 'aluno',
  titulo: 'Portal do Aluno',
  urlAlteraSenha: 'https://alterasenha.ftc.br',
  urlApi: host + '/UniFTCOne',
  urlApiAcesso: host + '/Acessos',
  urlApiAgendamentos: host + '/Agendamentos',
  //urlApiAgendamentos: 'http://localhost:8080/Agendamentos',
  urlApiAluno: host + '/FTCOneBack',
  urlApiApoioAluno: host + '/ApoioAluno',
  urlApiArquivo: host + '/Arquivos',
  urlApiAviso: host + '/Avisos',
  urlApiBolsas: host + '/Bolsas',
  urlApiCalendario: host + '/Calendario',
  urlApiCampanhas: host + '/Campanhas',
  urlApiEnvioArquivos: host + '/SecretariaUpload',
  urlApiGoogle: host + '/2FA',
  urlApiLogin: host + '/LoginBack',
  urlApiLyceum: host + '/Lyceum',
  urlApiPagamentos: host + '/Pagamentos',
  urlApiPesquisaSatisfacao: host + '/ExperienciaUniFTC', //novo
  urlApiChatAtendimento: host + '/ChatAtendimento',
  urlComprovanteMatricula:
    'https://comprovantedematricula.ftc.br/Home/capturaPessoa/',
  urlGeradorBoletos: `https://gerboleto.uniftc.edu.br/GeradorBoletos/GeraBoleto?boleto=`,
  urlGeraComprovantePagamento:
  'https://gerboleto.uniftc.edu.br/GeradorBoletos/GeraComprovantePagamento?codigo=',
  urlLoginPortalAluno: 'https://portalaluno.ftc.br/aonline/autologin.jsp',
  urlLoginPortalDocente: 'https://portaldocente.ftc.br/donline/autologin.jsp',
  urlReport: '',
  urlTopdesk: 'https://topdesk.uniftc.edu.br',
  urlPortalDoAluno: 'https://aluno.ftc.br/'
};
